import React from 'react';
import Icon from '../../../components/AppIcon';

const ScenarioCard = ({ scenario }) => {
  return (
    <div className="bg-card rounded-2xl p-6 shadow-card border border-border">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Target" size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h2 className="text-xl font-semibold text-foreground mb-2">
            {scenario?.title}
          </h2>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Clock" size={16} />
            <span>{scenario?.estimatedTime} min</span>
            <span className="w-1 h-1 rounded-full bg-muted-foreground" />
            <span className="capitalize">{scenario?.difficulty}</span>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        <div>
          <h3 className="text-sm font-semibold text-foreground mb-2 flex items-center gap-2">
            <Icon name="User" size={16} color="var(--color-primary)" />
            Customer Profile
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {scenario?.customerProfile}
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-foreground mb-2 flex items-center gap-2">
            <Icon name="MessageSquare" size={16} color="var(--color-primary)" />
            Situation
          </h3>
          <p className="text-sm text-foreground leading-relaxed">
            {scenario?.situation}
          </p>
        </div>

        <div className="bg-accent/10 rounded-lg p-4 border border-accent/20">
          <h3 className="text-sm font-semibold text-accent-foreground mb-2 flex items-center gap-2">
            <Icon name="Lightbulb" size={16} color="var(--color-accent)" />
            Your Challenge
          </h3>
          <p className="text-sm text-accent-foreground leading-relaxed">
            {scenario?.challenge}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScenarioCard;